import cn from 'classnames';

export default function Partner({ partner, className, prefix }) {
  return <p className={cn(`${prefix}text-xs ${prefix}leading-none`, className)}>{partner}</p>;
}
